import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

class TicketMacrosService {
  private getHeaders() {
    const token = localStorage.getItem('accessToken');
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
  }

  async list() {
    const res = await axios.get(`${API_BASE_URL}/admin/ticket-macros`, { headers: this.getHeaders() });
    return res.data.data.docs || [];
  }

  async create(payload: { name: string; description?: string; actions: any[] }) {
    const res = await axios.post(`${API_BASE_URL}/admin/ticket-macros`, payload, { headers: this.getHeaders() });
    return res.data.data.doc;
  }

  async update(id: string, payload: { name: string; description?: string; actions: any[] }) {
    const res = await axios.patch(`${API_BASE_URL}/admin/ticket-macros/${id}`, payload, { headers: this.getHeaders() });
    return res.data.data.doc;
  }

  async remove(id: string) {
    await axios.delete(`${API_BASE_URL}/admin/ticket-macros/${id}`, { headers: this.getHeaders() });
  }

  async execute(id: string, ticketId: string) {
    await axios.post(`${API_BASE_URL}/admin/ticket-macros/${id}/execute`, { ticketId }, { headers: this.getHeaders() });
  }
}

export default new TicketMacrosService();


